var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BFE2DEF4-C26A-4F81-ACF4-6FDA6D33A5DD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-12.7%",
    y: "-18.3%",
    width: "125.3%",
    height: "163.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 8,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0911175272 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "investment-viewfinder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "welcome",
    transform: "translate(-653.000000, -157.000000)",
    fill: "#8A8888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(135.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration",
    transform: "translate(505.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bubbles",
    filter: "url(#filter-1)",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_chart",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,9 L14,9 L14,20 L10,20 L10,9 Z M15,4 L19,4 L19,20 L15,20 L15,4 Z M5,11 L9,11 L9,20 L5,20 L5,11 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChart);
export default __webpack_public_path__ + "static/media/ic_chart.69560f6bdfebc32e97ff59761a937581.svg";
export { ForwardRef as ReactComponent };